import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const USER_LIST = 'user list'

export default {
  [PORTUGUESE]: {
    [USER_LIST]: 'Lista de Usuários',
  },

  [ENGLISH]: {
    [USER_LIST]: 'User List',
  },

  [SPANISH]: {
    [USER_LIST]: 'Lista de Usuarios',
  },
}
